import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 16.6667H15", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.0023 3.33337V13.3334M12.9189 10.4167L10.0023 13.3334L7.08561 10.4167", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
